import request from '@/utils/request'

// 车辆管理API
export const vehicleApi = {
  // 分页查询车辆信息
  getVehicleList(params) {
    return request({
      url: '/vehicle/list',
      method: 'get',
      params
    })
  },

  // 根据车辆ID获取车辆详情
  getVehicleDetail(vehicleId) {
    return request({
      url: `/vehicle/detail/${vehicleId}`,
      method: 'get'
    })
  },

  // 添加车辆信息
  addVehicle(data) {
    return request({
      url: '/vehicle/add',
      method: 'post',
      data
    })
  },

  // 更新车辆信息
  updateVehicle(data) {
    return request({
      url: '/vehicle/update',
      method: 'post',
      data
    })
  },

  // 删除车辆信息
  deleteVehicle(vehicleId) {
    return request({
      url: `/vehicle/delete/${vehicleId}`,
      method: 'delete'
    })
  }
} 